import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../services/auth.service';
import { UtilitaService } from '../services/utilita.service';
import { ConfermaPagamentoComponent } from './conferma-pagamento/conferma-pagamento.component';
import { GeneraRicevutaComponent } from './genera-ricevuta/genera-ricevuta.component';

@Component({
  selector: 'app-gestisci-ricevute',
  templateUrl: './gestisci-ricevute.component.html',
  styleUrls: ['./gestisci-ricevute.component.css']
})
export class GestisciRicevuteComponent implements OnInit {
  txtFiltra: any;
  lstElenco: any
  lstElencoPerUpdateFilter: any

  constructor(private srvUtilita: UtilitaService,
    private authService: AuthService,
    private dialog: MatDialog) { }


  ngOnInit(): void {
    this.getLista();
  }

  getLista() {
    this.srvUtilita.getLista('Utenti/GetElencoRichiesteInAttesaDiRicevuta').subscribe((res: any) => {
      this.lstElenco = res
      this.lstElencoPerUpdateFilter = res;
      //   console.log('res', res)
    })
  }

  btnGeneraRicevuta() {
    // console.log('ivalore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(GeneraRicevutaComponent, {
      width: '720px',
      disableClose: false,
      data: {}
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista();
      })
  }

  btnConfermaPagamento() {
    // console.log('ivalore', iValore)
    let dialogRef: MatDialogRef<any> = this.dialog.open(ConfermaPagamentoComponent, {
      width: '720px',
      disableClose: false,
      data: {  }
    })
    dialogRef.afterClosed()
      .subscribe((res: any) => {
        this.txtFiltra = '';
        this.getLista();
      })
  }


  updateFilter(event: any) {
   const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }


}
